import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NofeshService } from "../nofesh.service";
import { INofesh } from "../model/nofesh";
import { UserMessagesService } from "app/shared/user-messages/user-messages.service";
import { ResultOfOperation } from "../../shared/model/result-of-operation.model";
import { ENofeshType } from "../../shared/enums/enofesh-type.enum";
import { ConfigService } from "app/shared/config.service";
import { NofshonReservationTimerService } from "app/shared/timer/nofshon-reservation-timer.service";
import { INofeshSelected } from "app/shared/interfaces/Inofesh-selected.interface";
import { NofshonimService } from "app/nofshonim-chul/nofshonim.service";
import { Subscription } from "rxjs";
import { SpinnerService } from "app/shared/spinner/spinner.service";

@Component({
    moduleId: module.id,
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
    apiUrl: string = "";
    nofashim: INofesh[];
    selectedNofesh: INofesh;
    userSelectedNofesh: INofeshSelected;
    selectedNofashimForPanel: INofesh[] = [];
    userSelectedNofashimForPanel: INofeshSelected[];
    nofesh_syllabus_file_url: string = `${this.apiUrl}/UploadFiles/NofeshSyllabus/`
    selected_nofesh_id: number;
    nofeshPnim: INofesh[];
    meurganimPnim: INofesh[];
    nofshonChul: INofesh[];
    meurganimChul: INofesh[];
    mishpachotChul: INofesh[];
    favoritesNofashim: INofesh[] = [];
    username: string;
    timerTimeoutSubscription: Subscription;


    constructor(
        private _router: Router,
        private userMessagesService: UserMessagesService,
        private _configService: ConfigService,
        private _nofeshService: NofeshService,
        private _userMessages: UserMessagesService,
        private _nofshonimService: NofshonimService,
        private _nofshonReservationTimerService: NofshonReservationTimerService,
        private _spinnerService: SpinnerService
    ) {
        this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
    }


    async ngOnInit() {
        this._spinnerService.showSpinner();

        document.getElementById('menuDiv').style.display = 'none';


        if ("navigatedFromLogin" in sessionStorage) {
            console.log("Home - navigated from login");
            sessionStorage.removeItem("navigatedFromLogin");
            const nofashim = JSON.parse(sessionStorage.getItem("nofashim"));
            this._onNofashimReceived(nofashim);
           
            this.userSelectedNofesh = JSON.parse(sessionStorage.getItem("userSelectedNofesh"));
            console.log("Home - user selected nofesh from storage", this.userSelectedNofesh);

        }
        else {
            console.log("Home - navigated from other page");
            console.log("Home - updating user data and nofashim");
            console.log("Home - awaiting updates");
            await this._updateUserSelectedNofesh();
            await this._updateNofashim();
            console.log("Home - awaiting updates finish");
            if (!this.userSelectedNofesh.isReservationCompleted) {
                sessionStorage.removeItem("moed-rishum");
                sessionStorage.removeItem("nofshon-nirshamim");
                sessionStorage.removeItem("nofshon-tashlumim");
            }
        }

        this._nofshonimService.getUserReservedNofashim().subscribe(res => {
            this.userSelectedNofashimForPanel = res;
            if (this.userSelectedNofashimForPanel != null) {
                this.userSelectedNofashimForPanel.forEach
                    (nofesh => this.selectedNofashimForPanel.push(this.nofashim.find(c => c.id_nofesh === nofesh.id_nofesh))
                    )
            }
        });


        console.log("Home - nofashim on home init", this.nofashim);
        this.selectedNofesh = this.nofashim.find(c => c.id_nofesh === this.userSelectedNofesh.id_nofesh);
        console.log("Home - selected nofesh", this.selectedNofesh);

        this.setUsername(this.userSelectedNofesh);

        if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh) && this.userSelectedNofesh.id_reservation > 0 && !this.userSelectedNofesh.isReservationCompleted) {
            this._nofshonReservationTimerHandler();
        }

        this._spinnerService.hideSpinner();

        console.log("Home - on init finish");
        console.log("");
    }

    private _onNofashimReceived(nofashim: INofesh[]): void {
        console.log("Home - onNofashimReceived", nofashim);

        this.nofashim = nofashim.filter(n => n.k_pail > 0);
        if (this.nofashim.length > 0) {
            this.nofeshPnim = this.nofashim.filter(t => t.nofeshType == ENofeshType.NofeshPnim);
            this.meurganimPnim = this.nofashim.filter(n => n.nofeshType === ENofeshType.MeurganimPnim);
            this.nofshonChul = this.nofashim.filter(t => t.nofeshType == ENofeshType.NofeshChul);
            this.meurganimChul = this.nofashim.filter(t => t.nofeshType == ENofeshType.MeurganimChul);
            this.mishpachotChul = this.nofashim.filter(nofesh => nofesh.nofeshType == ENofeshType.MishpachotChul);

            if ("nofashim" in sessionStorage) {
                sessionStorage.removeItem("nofashim");
            }
            sessionStorage.setItem("nofashim", JSON.stringify(nofashim));

            this._nofeshService.getFavoritesNofashim().subscribe(result => {
                if (result.data) {
                    this.favoritesNofashim = nofashim.filter(n => n.id_nofesh == result.data.id_nofesh_1 || n.id_nofesh == result.data.id_nofesh_2 || n.id_nofesh == result.data.id_nofesh_3);
                }
            }, error => console.log(error));
        }
        else {
            this.userMessagesService.setErrorMessage("אין נופשים להצגה");
        }
        console.log("Home - onNofeshimReceived finish");
    }


    setUsername(userSelectedNofesh: INofeshSelected): void {
        const { shem_prati, shem_mishpacha } = userSelectedNofesh;
        this.username = `${shem_prati} ${shem_mishpacha}`;
    }

    private _nofshonReservationTimerHandler(): void {
        console.log("Home - timer handler on page load");

        this._nofshonimService.notifyHomePageHasTimer();

        const reservationExpiration = this._nofshonReservationTimerService.getReservationExpiration(this.userSelectedNofesh.moed_rishum);
        const isExpired = this._nofshonReservationTimerService.checkIfTimerTimedOut(reservationExpiration);
        if (isExpired) {
            console.log("Home - timer is expired");
            this._nofshonReservationTimerService.showTimedOutTimer();

            console.log("Home - notify timer timeout");
            this._nofshonimService.notifyHomePageTimerTimeout();

            console.log("Home - expired timer - cancel reservation on timer timeout");
            this._cancelNofshonReservationOnTimerTimeout();
        }
        else {
            console.log("Home - resuming timer");
            this._nofshonReservationTimerService.resumeTimer(reservationExpiration);

            this.timerTimeoutSubscription = this._nofshonReservationTimerService.timerTimeout$.subscribe((isTimeout: boolean) => {
                console.log("Home - resumed timer timeout notified. Is timeout?", isTimeout);
                if (isTimeout) {
                    console.log("Home - notify resumed timer timeout");
                    this._nofshonimService.notifyHomePageTimerTimeout();

                    console.log("Home - cancel reservation on resumed timer timeout");
                    this._cancelNofshonReservationOnTimerTimeout();
                    this.timerTimeoutSubscription.unsubscribe();
                }
            });
        }
    }

    private _cancelNofshonReservationOnTimerTimeout() {
        this._nofshonimService.cancelNofshonReservation(this.userSelectedNofesh.id_nofesh)
            //this.userSelectedNofesh.id_nofesh
            .subscribe((cancelResponse: ResultOfOperation<boolean>) => {
                console.log("Home - cancel reservation on timeout result", cancelResponse);
                if (cancelResponse.isSuccess) {
                    this._nofshonReservationTimerService.stopTimer();
                    this._nofshonReservationTimerService.hideTimer();
                    const message = "זמן שמירת ההזמנה פג. ההזמנה בוטלה";
                    this._userMessages.showSnackBarErrorMessage(message, null, this.userMessagesService.clearAll.bind(this.userMessagesService));
                    this._userMessages.setErrorMessage(message);
                    this._nofshonimService.clearSessionOnCancelReservation(this.userSelectedNofesh.id_nofesh);
                }
                else {
                    console.error("Failed to cancel reservation");
                }

                this._updateNofashim();
                this._updateUserSelectedNofesh();
            },
                error => {
                    console.error("Error in cancel reservation", error);
                    this._nofshonReservationTimerService.hideTimer();
                }
            );
    }

    // cancelReservationByUser(i: number): void {
    //     console.log("Home - cancel reservation", this.userSelectedNofesh);

    //     this.userMessagesService.clearAll();
    //     if (this.userSelectedNofesh.isNofshon) {
    //         this._cancelNofshonReservationByUser(i);
    //     }
    //     else if (!this.userSelectedNofesh.isNofshon) {
    //         this._cancelNofeshReservationByUser(i);
    //     }
    // }

    // private _cancelNofshonReservationByUser(i: number) {

    cancelReservationByUser(index: number): void {
        console.log("Home - cancel reservation", this.userSelectedNofesh);
        this.userMessagesService.clearAll();
        var selected = this.userSelectedNofashimForPanel[index];
        //if (this.userSelectedNofesh.isNofshon) {
        if (selected.isNofshon) {
            this._cancelNofshonReservationByUser(selected);
        }
        else if (!selected.isNofshon) {
            this._cancelNofeshReservationByUser(selected);
        }
    }
    // private _cancelNofshonReservationByUser() {
    //     if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh) && this.userSelectedNofesh.id_reservation > 0 && !this.userSelectedNofesh.isReservationCompleted && this._nofshonReservationTimerService.checkIfInMinimalPeriodToStopTimer(this.userSelectedNofesh.moed_rishum)) {
    //         this._nofshonReservationTimerService.stopTimer();
    //         this._nofshonReservationTimerService.hideTimer();
    //         console.log("Home - cancel reservation by user on minimal timer time. Timer is stopped");
    //     }

    //     console.log("Home - cancel nofshon reservation");
    //     const cancelReservationSubscription = this._nofshonimService.cancelNofshonReservation(this.userSelectedNofesh.id_nofesh)
    //         //
    //         .subscribe((cancelResponse: ResultOfOperation<boolean>) => {
    //             console.log("Home - cancel reservation by user result", cancelResponse);

    //             cancelReservationSubscription.unsubscribe();

    //             if (!cancelResponse.isSuccess || !cancelResponse.data) {
    //                 this._showNotificationForFailedReservationCancel();
    //                 return;
    //             }


    //             if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh) && this._nofshonReservationTimerService.isTimerShown && this.userSelectedNofesh.id_reservation > 0 && !this.userSelectedNofesh.isReservationCompleted) {
    //                 this._nofshonReservationTimerService.stopTimer();
    //                 this._nofshonReservationTimerService.hideTimer();
    //                 console.log("Home - cancel reservation by user. Timer is stopped");
    //             }

    //             this._nofshonimService.clearSessionOnCancelReservation(this.userSelectedNofesh.id_nofesh);
    //             this._onCancelReservationSuccess();
    //         },
    //             error => {
    //                 cancelReservationSubscription.unsubscribe();
    //                 console.error("Error in cancel nofshon reservation", error);
    //                 this._showNotificationForFailedReservationCancel();
    //             }
    //         );
    // }



    private _cancelNofshonReservationByUser(selected: INofeshSelected) {

        if (this._nofshonimService.shouldDisplayTimer(selected) && selected.id_reservation > 0 && !selected.isReservationCompleted && this._nofshonReservationTimerService.checkIfInMinimalPeriodToStopTimer(selected.moed_rishum)) {
            this._nofshonReservationTimerService.stopTimer();
            this._nofshonReservationTimerService.hideTimer();
            console.log("Home - cancel reservation by user on minimal timer time. Timer is stopped");
        }

        console.log("Home - cancel nofshon reservation");
        const cancelReservationSubscription = this._nofshonimService.cancelNofshonReservation(selected.id_nofesh)
            //
            .subscribe((cancelResponse: ResultOfOperation<boolean>) => {
                console.log("Home - cancel reservation by user result", cancelResponse);

                cancelReservationSubscription.unsubscribe();

                if (!cancelResponse.isSuccess || !cancelResponse.data) {
                    this._showNotificationForFailedReservationCancel();
                    return;
                }


                if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh) && this._nofshonReservationTimerService.isTimerShown && this.userSelectedNofesh.id_reservation > 0 && !this.userSelectedNofesh.isReservationCompleted) {
                    this._nofshonReservationTimerService.stopTimer();
                    this._nofshonReservationTimerService.hideTimer();
                    console.log("Home - cancel reservation by user. Timer is stopped");
                }

                this._nofshonimService.clearSessionOnCancelReservation(this.userSelectedNofesh.id_nofesh);
                this._onCancelReservationSuccess();
            },
                error => {
                    cancelReservationSubscription.unsubscribe();
                    console.error("Error in cancel nofshon reservation", error);
                    this._showNotificationForFailedReservationCancel();
                }
            );
    }



    private _cancelNofeshReservationByUser(selected: INofeshSelected): void {
        // private _cancelNofeshReservationByUser(): void {
        console.log("Home - cancel nofesh reservation");
        const cancelReservationSubscription = this._nofeshService.cancelNofeshReservation(selected.id_nofesh)
            .subscribe((cancelResponse: ResultOfOperation<boolean>) => {
                console.log("Home - cancel nofesh response", cancelResponse);

                cancelReservationSubscription.unsubscribe();
                if (!cancelResponse.isSuccess || !cancelResponse.data) {
                    this._showNotificationForFailedReservationCancel();
                    return;
                }

                this._nofshonimService.clearSessionOnCancelReservation(selected.id_nofesh);
                this._onCancelReservationSuccess();
            },
                (error) => {
                    cancelReservationSubscription.unsubscribe();
                    console.error("Error in cancel nofesh reservation", error);
                    this._showNotificationForFailedReservationCancel();
                });
    }

    private _onCancelReservationSuccess(): void {
        this._updateNofashim();
        this._updateUserSelectedNofesh();
        this.selectedNofesh = null;

        const message = "ההזמנה בוטלה בהצלחה";
        //this.userMessagesService.showSnackBarSuccessMessage(message, null, this.userMessagesService.clearAll.bind(this.userMessagesService));
        var ref = this.userMessagesService.showSnackBarSuccessMessage(message, null, this.userMessagesService.clearAll.bind(this.userMessagesService));
        this.userMessagesService.setSuccessMessage(message);
        console.log("try reload page");
        ref.afterDismissed().subscribe(_ => window.location.reload());
    }

    private _showNotificationForFailedReservationCancel(): void {
        const message = "אירעה שגיאה בעת ביצוע הביטול. הנופש לא בוטל";
        this._userMessages.setErrorMessage(message);
        this._userMessages.showSnackBarErrorMessage(message, 5000, this._userMessages.clearAll.bind(this._userMessages));
        this._nofeshService.notifyFailedToCancelReservation();
    }


    private async _updateNofashim(): Promise<void> {
        const nofashimResponse: ResultOfOperation<INofesh[]> = await this._nofeshService.getAllNofashim().toPromise();
        console.log("Home - update nofashim response", nofashimResponse);
        if (nofashimResponse && nofashimResponse.isSuccess && nofashimResponse.data) {
            this._onNofashimReceived(nofashimResponse.data)
        }
        else {
            console.error("Failed to get updated nofashim");
            window.location.reload();
        }
        console.log("Home - update nofashim finish");
    }

    private async _updateUserSelectedNofesh(): Promise<void> {
        console.log("Home - update user selected nofesh start");
        const userSelectedNofesh: INofeshSelected = await this._nofeshService.getUserSelectedNofesh(-1).toPromise();
        //userSelectedNofesh-חזר ריק מdb ?ולא מתאתחל בכלל 
        console.log("Home - updated user selected nofesh", userSelectedNofesh);
        if (userSelectedNofesh) {
            this.userSelectedNofesh = userSelectedNofesh;
            sessionStorage.setItem("userSelectedNofesh", JSON.stringify(userSelectedNofesh));
        }
        else {
            console.error("Failed to get updated user selected nofesh");
        }

        console.log("Home - update user selected nofesh finish");
    }

    nofeshDetails(event, nofeshId: number, nofeshType: number): void {
        event.preventDefault();
      
        if (!this.userSelectedNofesh) {
            this._userMessages.showSnackBarErrorMessage("לא ניתן לעיין בפרטי הנופש", 3000)
            return;
        }

        this._userMessages.clearAll();

        switch (nofeshType) {
            case ENofeshType.NofeshPnim:
            case ENofeshType.MeurganimPnim:
                this._router.navigate(['nofesh-pnim/nofesh-details/' + nofeshId]);
                break;
            case ENofeshType.NofeshChul:
                this._router.navigate(['nofshonim-chul/nofesh-details/' + nofeshId]);
                break;
            case ENofeshType.MeurganimChul:
                this._router.navigate(['nofesh/nofesh-details/' + nofeshId]);
                break;
            case ENofeshType.MishpachotChul:
                this._router.navigate([`mishpachot-chul/nofesh-details/${nofeshId}`]);
                break;
        }
    }

    onNofeshSelected(id_nofesh: number) {
        this.selected_nofesh_id = id_nofesh;
    }

    redirectToLogin() {
        this._userMessages.clearSnackBarMessage();
        this._router.navigate(['/login'], { queryParams: { nav: 'nofesh' } });
    }

    ngOnDestroy(): void {
        if (this.timerTimeoutSubscription) {
            this.timerTimeoutSubscription.unsubscribe();
        }
    }
}